var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wxapp-customMessagepage"},[_c('SpFinder',{ref:"finder",attrs:{"url":_vm.page_list,"noSelection":"","setting":_vm.pageSetting,"fixed-row-action":"","split-count":10,"hooks":{ beforeSearch: _vm.beforeSearch },"rowActionsWidth":"130px","rowActionsAlign":"left"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }